import { defineMessages } from 'react-intl';

export const diagnocoinAdjustmentModalMessages = defineMessages({
  title: {
    id: 'diagnocoinAdjustmentModal.title',
    defaultMessage: 'Subtract Diagnocoins',
  },
  content: {
    id: 'diagnocoinAdjustmentModal.content',
    defaultMessage:
      'The coins are removed from this top-up for good and cannot be returned. The clinic sees the correction in its coin history.',
  },
  batchSummary: {
    id: 'diagnocoinAdjustmentModal.batchSummary',
    defaultMessage:
      'Top-up of {purchasedAt}: {available} of {total, plural, one {# coin} other {# coins}} available',
  },
  amountLabel: {
    id: 'diagnocoinAdjustmentModal.amountLabel',
    defaultMessage: 'Coins to subtract',
  },
  amountValidation: {
    id: 'diagnocoinAdjustmentModal.amountValidation',
    defaultMessage: 'Enter a whole number from 1 to {max}',
  },
  okText: {
    id: 'diagnocoinAdjustmentModal.okText',
    defaultMessage: 'Subtract',
  },
  cancelText: {
    id: 'global.cancel',
    defaultMessage: 'Cancel',
  },
  success: {
    id: 'diagnocoinAdjustmentModal.success',
    defaultMessage: 'Diagnocoins subtracted',
  },
});
